module.exports = __webpack_public_path__ + "img/sec8desk.af02fec9.png";